import { mdiTextBoxPlusOutline } from '@mdi/js';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AppIcon from './AppIcon';

/**
 * Icon that shows the user that a document has additional documents associated with it, as well as how many.
 */
export default ({ count }: IDocAdditionalIconProps) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'docTable' });

    /** Adjust translation key depending on the number of additional documents. */
    const key = count > 1 ? 'tooltipAdditionalDocs' : 'tooltipAdditionalDoc';

    return count ? (
        <AppIcon
            path={mdiTextBoxPlusOutline}
            tooltipText={t(key, { count })}
            tooltipPlacement='top-start'
        />
    ) : (
        <></>
    );
};

/**
 * Interface that describes the props for a DocAdditionalIcon component.
 */
export interface IDocAdditionalIconProps {
    /** Total number of additional documents. */
    count: number;
}
